var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnderline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1555 6.04756H13.2215V11.8761C13.2215 12.4779 13.0796 13.0152 12.7959 13.488C12.5151 13.958 12.1182 14.3291 11.6053 14.6013C11.0924 14.8706 10.4906 15.0053 9.79998 15.0053C9.10938 15.0053 8.50761 14.8706 7.99467 14.6013C7.48174 14.3291 7.08342 13.958 6.79973 13.488C6.5189 13.0152 6.37849 12.4779 6.37849 11.8761V6.04756H7.44448V11.7902C7.44448 12.22 7.53905 12.6025 7.72818 12.9378C7.9173 13.2702 8.18667 13.5324 8.53627 13.7244C8.88873 13.9135 9.30997 14.0081 9.79998 14.0081C10.29 14.0081 10.7112 13.9135 11.0637 13.7244C11.4162 13.5324 11.6855 13.2702 11.8718 12.9378C12.0609 12.6025 12.1555 12.22 12.1555 11.7902V6.04756Z",
    fill: "#38cb89"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.3125,
    y: 16.6836,
    width: 9.51042,
    height: 0.864583,
    fill: "#38cb89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/underline.fc80c3b8a5a89afefc5724df2b7414fd.svg";
export { ForwardRef as ReactComponent };